import { ThemeProvider } from "@emotion/react";
import { NonConflictingThemeProvider } from "src/lib/emotion/NonConflictingThemeProvider.tsx";
import { type PropsWithChildren, useMemo } from "react";
import { useNonConflictingTheme } from "src/lib/emotion/use-non-conflicting-theme.ts";
import type { ExactTheme } from "src/lib/emotion/theme.ts";
import { mapObject } from "@exonn/utils";

// inspired by: https://fatfisz.com/blog/solving-z-index-with-styled-components
export const LevelUp = ({
  children,
  type,
}: PropsWithChildren<{ type: keyof ExactTheme["zIndices"] }>) => {
  const theme = useNonConflictingTheme();
  const nextTheme = useMemo(() => {
    const nextZIndices = mapObject(
      theme.zIndices,
      (value) => value + theme.zIndices[type],
    );
    return {
      ...theme,
      zIndices: nextZIndices,
    };
  }, [theme, type]);
  return (
    <ThemeProvider theme={nextTheme}>
      <NonConflictingThemeProvider theme={nextTheme}>
        {children}
      </NonConflictingThemeProvider>
    </ThemeProvider>
  );
};
